import { BrowserRouter, Route, Routes } from "react-router-dom";
import MainPage from "./features/MainPage";
import PricePage from "./features/PricePage";
import Navigation from "./features/Navigation";
import { path } from "./settings";
import MorePage from "./features/MorePage";
import { Main } from "./styled";

function App() {
  return (
    <BrowserRouter >
      <Navigation />
      <Main>
        <Routes>
          <Route
            element={<MainPage />}
            path={path.home}
          />
          <Route
            element={<PricePage />}
            path={path.prices}
          />
          <Route
            element={<MorePage />}
            path={path.more}
          />
        </Routes>
      </Main>
    </BrowserRouter>
  );
}

export default App;